module.exports = __webpack_public_path__ + "img/cover-recipy.0a92c88a.png";